import { Component, OnInit } from '@angular/core';

// env
import { environment } from '../../../environments/environment';

// Plugin
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-widget-documents',
  templateUrl: './widget-documents.component.html',
})
export class WidgetDocumentsComponent implements OnInit {

  dataAnnual;
  dataYear = [];
  dataPerAnnual;
  year;
  isLang;
  apiAsset = environment.API_ASSETS;

  constructor( private apiService: ApiService ) {  }

  ngOnInit(): void {
    // MultiLanguage
    this.isLang =  this.apiService.isLang();

     // Docs
     this.apiService.getDataApi('getDocumentYear?category=3').subscribe(response => {
      this.dataAnnual = response.data;
       response.data.forEach((i,x) => {
         if(i.year){
           this.dataYear.push(i.year);
         }
         this.year = this.dataYear[0];
         if(this.year == i.year){
           this.dataPerAnnual = i.content[0];
         }
       });
    });
  }

  valueChanged(event: string) {
    this.dataAnnual.forEach((i,x) => {
      if(i.year == event){
        this.dataPerAnnual = i.content[0];
      }
    });
  }

}
